import React, {Component} from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { Helmet } from 'react-helmet'
import * as ACTIONS from '../actions/Page'
import ScrollToPlugin from "gsap/ScrollToPlugin";
import * as Breakpoints from '../utils/Breakpoints';

import { 
  NavLink,
  withRouter
} from 'react-router-dom';

import { Blocks, Grid, Carousel, Sections, Container } from '../components';

const mapStateToProps = state => ({
  page: state.page.data,
  loading: state.page.loading
})

const mapDispatchToProps = (dispatch) => {
  return{
    fetchPage: bindActionCreators(ACTIONS.getPage, dispatch),
  }
  
}

class Page extends Component {

  constructor(props) {
    super(props);


  }
 
 componentDidMount() {
  let slug = this.props.entry.params.slug
  this.props.fetchPage(slug);
 }


 componentWillMount() {}


 

render () {

  console.log(this.state);
  let { page,loading } = this.props;

  if(loading) return null;
  
  const mods = page.acf.template.toLowerCase();
  return(

      <div className={"Template  Template--page Template--"+mods}>

        <Helmet>
          <title> Mancoba – {page.title.rendered }</title>  
        </Helmet>


        <Container>
        <div className={"Template-head Template-head--"+page.acf.title_position.toLowerCase()}>
          <h1 className="Template-title">{page.title.rendered}</h1>
        </div>
        </Container>

        <Breakpoints.Default>
         {page.acf.blocks && <Sections  blocks={page.acf.blocks} blockLength={page.acf.blocks.length} location={this.props.location.pathname.replace("/", "") } />}
        </Breakpoints.Default>

        <Breakpoints.Mobile>
         <div className="Template-blocks">
          {page.acf.blocks && <Blocks  blocks={page.acf.blocks} location={this.props.location.pathname.replace("/", "") } />}
        </div>
        </Breakpoints.Mobile>
       {/* <div className={"Template-slideshow "+(this.state.slideshow ? "Template-slideshow--open" : "")}>
          <div className="Template-slideshow-close" onClick={ () => { this.slideShowState(false) }}>Close</div>
          
          <div className="Template-slideshow-container">
            { page.acf.slideshow != undefined && <Carousel images={page.acf.slideshow} count={(page.acf.slideshow.length)} controls={true} auto={false} ratio={false}/>}
          </div>
          
        </div>*/}

      </div>  
       
    );

  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Page));



// WEBPACK FOOTER //
// ./src/js/templates/default.js